module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-bingdao-h5.65ad2941.jpg";